import React, { useState, useRef, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import DropdownProperties from "../common/DropdownProperties.jsx";
import DropdownSelectSZType from "../common/DropdownSelectSZType.js";
import { useGetAllProperties } from "../../APIs/MasterAPIHelper.js";
import { useSnackbar } from 'notistack';
import { PropertyFloor, BaseURL,NewProperty } from "../../APIs/APIUrls.js";
import { Link, useLocation } from "react-router-dom";
import { handleKeyPress } from "../../APIs/Helper.js";
import { useStates, useCities, GetAllFloorPlans, GetAllNoofBathrooms, GetAllNoofBedrooms } from "../../APIs/MasterAPIHelper";
import Pagination2 from "../common/Pagination2.jsx";

import SidebarMenu from "../../components/dashboard/SidebarMenu";
import Header2 from "../../components/headers/Header2";
import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Add Property Floor Plan || AskMeRealty - Real Estate",
  description: "AskMeRealty - Real Estate",
};

export default function AddFloorPlan() {

  const { enqueueSnackbar } = useSnackbar();
  const fetchAllProperties = useGetAllProperties();
  const location = useLocation();

  const vendorid = localStorage.getItem("id") || 0;

  // Safely parse token with fallback
  let Token = null;
  try {
    const tokenStr = localStorage.getItem('tcn');
    Token = tokenStr ? JSON.parse(tokenStr) : null;
  } catch (e) {
    console.error("Error parsing token:", e);
    Token = localStorage.getItem('tcn'); // Fallback to raw token if it's not JSON
  }

  //pagination and search filter states
  const [page, setPage] = useState(1);
  const [ItemsPerPage, setItemsPerPage] = useState(10);


  //My Properties useState
  const [myFloorPlan, setFloorPlans] = useState([]);
  const [myFloorPlanFilter, setFloorPlanFilter] = useState([]);

  const [PropertyIdFilter, setPropertyIdFilter] = useState("");
  const PropertyFilterref = useRef();
  const [queryPropertyId, setQueryPropertyId] = useState("");


  const [isDragging, setIsDragging] = useState(false); // Track drag state
  const [images, setImages] = useState([]);



  const validateFile = (file) => {
    const validExtensions = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxSizeInMB = 1.5;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (!validExtensions.includes(file.type)) {
      enqueueSnackbar('Only JPG and PNG files are allowed', { variant: 'warning' });
      return false;
    }

    if (file.size > maxSizeInBytes) {
      enqueueSnackbar(`File size must be less than ${maxSizeInMB}MB`, { variant: 'warning' });
      return false;
    }

    return true;
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file before processing
      if (!validateFile(file)) {
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result;
        console.log('New Images Array:', newImages);
        setImages(newImages);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDelete = (index) => {
    const newImages = images.filter((_, imgIndex) => imgIndex !== index);
    setImages(newImages);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files).slice(0, 10 - images.length);
    files.forEach((file, index) => {
      // Validate file before processing
      if (!validateFile(file)) {
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImages((prevImages) => {
          const newImages = [...prevImages];
          newImages[prevImages.length + index] = reader.result;
          return newImages;
        });
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true); // Add border on drag
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Remove border when dragging ends
  };

  const [lstProperties, setLstProperties] = useState([]);
  const [lstPropertiesFilter, setLstPropertiesFilter] = useState([]);
  const [PropertyId, setPropertyId] = useState("");
  const Propertyref = useRef();


  const [isLoading, setIsLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const [objNoOfBathrooms, setObjNoOfBathrooms] = useState([]);
  const [objNoOfBedrooms, setObjNoOfBedrooms] = useState([]);
  const [objFloorPlans, setObjFloorPlans] = useState([]);

  const [FloorPlanId, setFloorPlanId] = useState("");
  const [FloorPlanIdonedit, setFloorPlanIdonedit] = useState("");
  const FloorPlanRef = useRef();

  const [BathroomId, setBathroomId] = useState("");
  const [BathroomIdonedit, setBathroomIdonedit] = useState("");
  const BathroomRef = useRef();

  const [BedroomId, setBedroomId] = useState("");
  const [BedroomIdonedit, setBedroomIdonedit] = useState("");
  const BedroomRef = useRef();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const propertyIdFromQuery = params.get("id");

    if (propertyIdFromQuery && propertyIdFromQuery !== "0") {
      const normalizedId = String(propertyIdFromQuery);
      setQueryPropertyId(normalizedId);
      setPropertyId(normalizedId);
      setPropertyIdFilter(normalizedId);
    }
  }, [location.search]);

  useEffect(() => {
    const getDDLProperties = async () => {
      debugger
      try {
        const result = await fetchAllProperties();
        console.log('API Response:', result);
        if (result) {
          // Handle both: result.data (wrapped) and result (direct array)
          let properties = result.data || result;
          console.log('Properties array:', properties);

          if (Array.isArray(properties) && properties.length > 0) {
            const ddlOptions = properties.map(prop => ({
              PropertyGeneratedId: prop.PropertyGeneratedId + ": " + prop.PropertyTitle,
              PropertyId: String(prop.PropertyId)
            }));
            ddlOptions.unshift({ PropertyGeneratedId: "Select", PropertyId: "0" });
            setLstProperties(ddlOptions);
            setLstPropertiesFilter(
              queryPropertyId && queryPropertyId !== "0"
                ? ddlOptions.filter(
                  (item) => String(item.PropertyId) === String(queryPropertyId) || String(item.PropertyId) === "0"
                )
                : ddlOptions
            );
          }
        }
      } catch (error) {
        console.log('Error fetching properties:', error);
      }
    };

    getDDLProperties();
    // Fetch my property images (non-critical)
    fnGetMyFloorPlans().catch(err => {
      console.warn('Optional: Could not fetch property images', err);
    });
  }, [queryPropertyId])

  useEffect(() => {

    const fetchData = async () => {
      try {
        const noOfBathrooms = await GetAllNoofBathrooms();
        const noOfBedrooms = await GetAllNoofBedrooms();
        const floorPlans = await GetAllFloorPlans();
        setObjNoOfBathrooms(noOfBathrooms);
        setObjNoOfBedrooms(noOfBedrooms);
        setObjFloorPlans(floorPlans);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [])

  const handleAddImages = async () => {
    debugger
    // Validation
    if (!PropertyId || PropertyId === "0") {
      enqueueSnackbar('Please select a property', { variant: 'warning' });
      return;
    }

    if (!FloorPlanId || FloorPlanId === "0") {
      enqueueSnackbar('Please select a floor plan', { variant: 'warning' });
      return;
    }

    if (!BedroomId || BedroomId === "0") {
      enqueueSnackbar('Please select a bedroom', { variant: 'warning' });
      return;
    }

    if (!BathroomId || BathroomId === "0") {
      enqueueSnackbar('Please select a bathroom', { variant: 'warning' });
      return;
    }

    const filterFloorflag = myFloorPlan.some(item => item.PropertyId == PropertyId && item.FloorTypeId == FloorPlanId);
    if (filterFloorflag) {
      enqueueSnackbar('Same floor plan is already exists in the chosen property.', { variant: 'warning' });
      return;
    }

    const filterBedroomsflag = myFloorPlan.some(item => item.PropertyId == PropertyId && item.FloorTypeId == FloorPlanId && item.BedroomId == BedroomId);
    if (filterBedroomsflag) {
      enqueueSnackbar('This floor plan with the floor plan and bedroom details already exists for the chosen property.', { variant: 'warning' });
    }

    const filterBathroomflag = myFloorPlan.some(item => item.PropertyId == PropertyId && item.FloorTypeId == FloorPlanId && item.BedroomId == BedroomId && item.BathroomId == BathroomId);
    if (filterBathroomflag) {
      enqueueSnackbar('This floor plan with the  floor plan, bedroom and bathroom details already exists for the chosen property.', { variant: 'warning' });
      return;
    }

    if (images.length === 0) {
      enqueueSnackbar('Please select at least one image', { variant: 'warning' });
      return;
    }

    if (images.length > 1) {
      enqueueSnackbar('Maximum 1 image allowed', { variant: 'warning' });
      return;
    }

    setIsLoading(true);

    try {
      // Create FormData to send images
      const formData = new FormData();
      formData.append('PropertyId', PropertyId);
      formData.append('FloorTypeId', FloorPlanId);
      formData.append('BedroomId', BedroomId);
      formData.append('BathroomId', BathroomId);

      // Add VendorId if available (optional based on updated API)
      if (vendorid) {
        formData.append('VendorId', vendorid);
      }

      // Add images to FormData
      images.forEach((imageBase64, index) => {
        // Convert base64 to blob
        const arr = imageBase64.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const str = atob(arr[1]);
        let n = str.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = str.charCodeAt(n);
        }
        const blob = new Blob([u8arr], { type: mime });
        formData.append('images', blob, `image-${index}.jpg`);
      });

      // Upload to API
      const response = await fetch(PropertyFloor + 'UploadPropertyFloor', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Token}`
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();

      // Check if all images uploaded successfully
      if (result.Success) {
        setUploadSuccess(true);
        enqueueSnackbar(`${result.SuccessCount} Floor details uploaded successfully!`, { variant: 'success' });
        setPropertyId("0");
        setFloorPlanIdonedit("0");
        setBathroomIdonedit("0");
        setBedroomIdonedit("0");
        setImages([]);
        fnGetMyFloorPlans();
      } else {
        enqueueSnackbar(`${result.SuccessCount} uploaded, ${result.FailedCount} failed`, { variant: 'warning' });
      }

      // Clear images and reset after 1.5 seconds
      setTimeout(() => {
        setImages([]);
        setUploadSuccess(false);
      }, 1500);

    } catch (error) {
      console.error('Error uploading images:', error);
      enqueueSnackbar('Error uploading images. Please try again.', { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const fnGetMyFloorPlans = async () => {
    try {
      const userId = localStorage.getItem("id") || vendorid;

      if (!userId) {
        enqueueSnackbar('User ID not found. Please login again.', { variant: 'error' });
        return;
      }

      if (!Token) {
        enqueueSnackbar('Authentication token not found. Please login again.', { variant: 'error' });
        return;
      }

      const response = await fetch(`${PropertyFloor}GetPropertyFloorByVendorId/${userId}`, {
        method: "POST", // Changed from POST to GET
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Token}`,
        }
      });


      if (response.isSuccess && response.Message == "Success") {
        enqueueSnackbar("No property images found.", { variant: "info" });
        return;
      }
      const text = await response.text();
      if (!text || text.trim() === "") {
        enqueueSnackbar("No data found.", { variant: "info" });
        setFloorPlans([]);
        return;
      }

      const result = JSON.parse(text);

      // Handle different response formats
      if (result.data) {
        setFloorPlans(result.data);
        setFloorPlanFilter(result.data);
      } else if (Array.isArray(result)) {
        setFloorPlans(result);
      } else {
        setFloorPlans([]);
      }

    } catch (error) {
      console.error("Error fetching property images:", error);
      enqueueSnackbar(`Error: ${error.message}`, { variant: "error" });
    }
  };



  const handleDeleteFloorPlan = async (floorId) => {
    try {
      debugger
      if (!Token) {
        enqueueSnackbar('Authentication token not found. Please login again.', { variant: 'error' });
        return;
      }

      const response = await fetch(`${PropertyFloor}DeletePropertyFloor/${floorId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify()
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();

      if (result.isSuccess) {
        enqueueSnackbar('Floor plan deleted successfully!', { variant: 'success' });

        const _myFloorPlanFilter = myFloorPlan.filter(item => item.FloorId !== floorId);
        setFloorPlanFilter(_myFloorPlanFilter);

      } else {
        enqueueSnackbar(result.Message || 'Failed to delete floor plan', { variant: 'warning' });
      }
    } catch (error) {
      console.error('Error deleting floor plan:', error);
      enqueueSnackbar('Error deleting floor plan. Please try again.', { variant: 'error' });
    }
  };


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const propertyIdFromQuery = params.get("id");

    const validateQueryString = async (propertyId) => {
      if (!propertyId || propertyId === "0") {
        return;
      }
      debugger
      const isNumericId = /^\d+$/.test(String(propertyId));
      if (!isNumericId) {
        enqueueSnackbar("Invalid property ID in the URL.", { variant: "error" });
        localStorage.clear();
        window.location.href = "/"; // Use full page reload to ensure all state is cleared
        return;
      }

      try {
        const tokenStr = JSON.parse(localStorage.getItem('tcn'));
        const vid = localStorage.getItem("id") || 0;

        const res = await fetch(`${NewProperty}GetNewPropertyByVendorId/${vid}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${tokenStr}`
          }
        });

        if (!res.ok) {
          throw new Error(`Request failed with status ${res.status}`);
        }

        const result = await res.json();
        const vendorProperties = Array.isArray(result?.data)
          ? result.data
          : result?.data
            ? [result.data]
            : Array.isArray(result)
              ? result
              : [];

        const isAllowed = vendorProperties.some((item) => String(item?.PropertyId) === String(propertyId));

        if (!isAllowed) {
          enqueueSnackbar(
            "Unauthorized or invalid property ID in the query string. Please check the URL.",
            { variant: "error" }
          );
          localStorage.clear();
          window.location.href = "/"; // Use full page reload to ensure all state is cleared
        }
      } catch (error) {
        console.log('Error validating query string:', error);
      }
    };

    validateQueryString(propertyIdFromQuery);
  }, [])


  useEffect(() => {
    const filterIdToUse = queryPropertyId && queryPropertyId !== "0" ? queryPropertyId : PropertyIdFilter;

    if (filterIdToUse && filterIdToUse !== "0") {
      const filteredProperties = myFloorPlan.filter(item => String(item.PropertyId) === String(filterIdToUse));
      setFloorPlanFilter(filteredProperties);
    } else {
      setFloorPlanFilter(myFloorPlan);
    }

  }, [PropertyIdFilter, myFloorPlan, queryPropertyId])


  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="layout-wrap">
        <Header2 />
        <SidebarMenu />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="button-show-hide show-mb">
              <span className="body-1">Show Dashboard</span>
            </div>

            <div className="widget-box-2 mb-20">
              <h5 className="title">Add Floor Plans</h5>
              <div className="box grid-3 gap-30" >
                <fieldset className="box-fieldset">
                  <label htmlFor="country">
                    {" "}
                    Property:<span>*</span>{" "}
                  </label>
                  <DropdownProperties
                    options={lstPropertiesFilter}
                    setItem={setPropertyId}
                    refItem={Propertyref}
                    StateValue={queryPropertyId && queryPropertyId !== "0" ? queryPropertyId : PropertyId}
                    disabledflag={!!queryPropertyId && queryPropertyId !== "0"}
                  />
                </fieldset>
                <fieldset className="box-fieldset">
                  <label htmlFor="type">
                    {" "}
                    Floor:<span>*</span>{" "}
                  </label>

                  <DropdownSelectSZType
                    options={objFloorPlans}
                    setItem={setFloorPlanId}
                    setRef={FloorPlanRef}
                    TypeValue={FloorPlanIdonedit}
                  />
                </fieldset>
                <fieldset className="box-fieldset">
                  <label htmlFor="type">
                    {" "}
                    No. of Bedrooms:<span>*</span>{" "}
                  </label>

                  <DropdownSelectSZType
                    options={objNoOfBedrooms}
                    setItem={setBedroomId}
                    setRef={BedroomRef}
                    TypeValue={BedroomIdonedit}
                  />
                </fieldset>
                <fieldset className="box-fieldset">
                  <label htmlFor="type">
                    {" "}
                    No. of Bathrooms:<span>*</span>{" "}
                  </label>
                  <DropdownSelectSZType
                    options={objNoOfBathrooms}
                    setItem={setBathroomId}
                    setRef={BathroomRef}
                    TypeValue={BathroomIdonedit}
                  />
                </fieldset>
              </div>
              <h5 className="title">Upload Media</h5>
              <div className="box-uploadfile text-center">
                <div
                  className="uploadfile"
                  style={
                    isDragging
                      ? { borderStyle: "solid", backgroundColor: "#f2f3f4" }
                      : {}
                  }
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                >
                  <a href="#" className="btn-upload tf-btn primary">
                    <svg
                      width={21}
                      height={20}
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.625 14.375V17.1875C13.625 17.705 13.205 18.125 12.6875 18.125H4.5625C4.31386 18.125 4.0754 18.0262 3.89959 17.8504C3.72377 17.6746 3.625 17.4361 3.625 17.1875V6.5625C3.625 6.045 4.045 5.625 4.5625 5.625H6.125C6.54381 5.62472 6.96192 5.65928 7.375 5.72834M13.625 14.375H16.4375C16.955 14.375 17.375 13.955 17.375 13.4375V9.375C17.375 5.65834 14.6725 2.57417 11.125 1.97834C10.7119 1.90928 10.2938 1.87472 9.875 1.875H8.3125C7.795 1.875 7.375 2.295 7.375 2.8125V5.72834M13.625 14.375H8.3125C8.06386 14.375 7.8254 14.2762 7.64959 14.1004C7.47377 13.9246 7.375 13.6861 7.375 13.4375V5.72834M17.375 11.25V9.6875C17.375 8.94158 17.0787 8.22621 16.5512 7.69876C16.0238 7.17132 15.3084 6.875 14.5625 6.875H13.3125C13.0639 6.875 12.8254 6.77623 12.6496 6.60041C12.4738 6.4246 12.375 6.18614 12.375 5.9375V4.6875C12.375 4.31816 12.3023 3.95243 12.1609 3.6112C12.0196 3.26998 11.8124 2.95993 11.5512 2.69876C11.2901 2.4376 10.98 2.23043 10.6388 2.08909C10.2976 1.94775 9.93184 1.875 9.5625 1.875H8.625"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Select photo
                    <input
                      type="file"
                      className="ip-file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, 0)}
                    />
                  </a>
                  <p className="file-name fw-5">
                    or drag photo here <br />
                    <span>(1 photo only)</span>
                  </p>
                </div>
              </div>
              <div className="box-img-upload">
                {images[0] && (
                  <div className="item-upload file-delete">
                    <img alt="img" src={images[0]} width={615} height={405} />
                    <span
                      className="icon icon-trash remove-file"
                      onClick={() => setImages([])}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="box-btn">

              <button
                className="tf-btn primary"
                onClick={handleAddImages}
                disabled={isLoading || images.length === 0}
                style={{
                  opacity: isLoading || images.length === 0 ? 0.6 : 1,
                  cursor: isLoading || images.length === 0 ? 'not-allowed' : 'pointer'
                }}
              >
                {isLoading && (
                  <span style={{ marginRight: '8px', display: 'inline-flex', alignItems: 'center' }}>
                    <ClipLoader size={16} color="currentColor" />
                  </span>
                )}
                {isLoading ? 'Uploading...' : uploadSuccess ? 'Uploaded ✓' : 'Add Image'}
              </button>
            </div>
            <div className="widget-box-2 wd-listing" style={{ marginTop: "30px" }}>
              <h5 className="title">All Floor Plans</h5>
              <div className="wrap-table">
                {/* <div className="box grid-3 gap-30" >
                  <fieldset className="box-fieldset">
                    <DropdownProperties
                      options={lstPropertiesFilter}
                      setItem={setPropertyIdFilter}
                      refItem={PropertyFilterref}
                      StateValue={queryPropertyId && queryPropertyId !== "0" ? queryPropertyId : PropertyIdFilter}
                      disabledflag={!!queryPropertyId && queryPropertyId !== "0"}
                    />
                  </fieldset>
                </div> */}
                <div className="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: "8%" }}>Sr No</th>
                        <th style={{ width: "10%" }}>Floor Plan</th>
                        <th>Property Id / Title</th>
                        <th style={{ width: "5%" }}>Floor Type</th>
                        <th style={{ width: "3%" }}>No. of Bedrooms</th>
                        <th style={{ width: "3%" }}>No. of Bathrooms</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        myFloorPlanFilter.slice((page - 1) * ItemsPerPage, page * ItemsPerPage).map((propertyItem, index) => (
                          <tr className="file-delete" key={index}>
                            <td style={{ width: "8%" }}>
                              <span style={{ marginLeft: "20px" }}>{(page - 1) * ItemsPerPage + index + 1}</span>
                            </td>
                            <td>
                              <div className="listing-box">
                                <div className="images" style={{ width: "80px" }}>
                                  <img
                                    alt="images"
                                    src={`${BaseURL}${propertyItem.FloorPlanImage}`}
                                    width={60}
                                    height={60}
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="listing-box">
                                <div className="content">
                                  <div className="title">
                                    <ul className="list-action">
                                      <li>
                                        <Link
                                          className="link"
                                        >
                                          {propertyItem.PropertyGeneratedId}
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={`/property-details-v1/${propertyItem.PropertyId}`}
                                          className="link"
                                        >
                                          {propertyItem.PropertyTitle}
                                        </Link>
                                      </li>
                                    </ul>

                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <ul className="list-action">
                                <li>
                                  < div className="widget-box-2" style={{ padding: "0px" }}>
                                    <div className="box-info-property">
                                      <fieldset className="box box-fieldset" style={{ marginBottom: "10px" }}>
                                        <label htmlFor="title">
                                          {propertyItem.FloorName}
                                        </label>
                                      </fieldset>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </td>
                            <td>
                              <ul className="list-action">
                                <li>
                                  < div className="widget-box-2" style={{ padding: "0px" }}>
                                    <div className="box-info-property">
                                      <fieldset className="box box-fieldset" style={{ marginBottom: "10px" }}>
                                        <label htmlFor="title">
                                          {propertyItem.Bedrooms}  {propertyItem.Bedrooms > 1 ? "Bedrooms" : "Bedroom"}
                                        </label>
                                      </fieldset>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </td>
                            <td>
                              <ul className="list-action">
                                <li>
                                  < div className="widget-box-2" style={{ padding: "0px" }}>
                                    <div className="box-info-property">
                                      <fieldset className="box box-fieldset" style={{ marginBottom: "10px" }}>
                                        <label htmlFor="title">
                                          {propertyItem.Bathrooms}  {propertyItem.Bathrooms > 1 ? "Bathrooms" : "Bathroom"}
                                        </label>
                                      </fieldset>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </td>
                            <td>
                              <ul className="list-action">
                                <li>
                                  <a className="btn btn-sm btn-danger" onClick={() => {
                                    if (window.confirm("Are you sure you want to delete this floor plan?")) {
                                      handleDeleteFloorPlan(propertyItem.FloorId);
                                    }
                                  }} >

                                    Delete
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>

                        ))}
                    </tbody>
                  </table>
                </div>
                <ul className="wd-navigation">
                  <Pagination2 itemLength={myFloorPlanFilter.length} itemPerPage={ItemsPerPage} setPage={setPage} />
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="overlay-dashboard" />
      </div>
    </>
  );
}
